var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20 10.0048C20 15.5137 15.5116 20 10 20C4.48842 20 0 15.5137 0 10.0048C0 4.48625 4.48842 0 10 0C15.5116 0 20 4.48625 20 10.0048Z",
    fill: "url(#paint0_linear_1404_34180)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.998 10.0049C13.998 10.2576 13.9185 10.5113 13.7594 10.7145C13.7296 10.7543 13.5904 10.9186 13.481 11.0255L13.4213 11.0838C12.5861 11.9694 10.508 13.3011 9.45401 13.7278C9.45401 13.7375 8.82759 13.9913 8.5293 14H8.48952C8.03214 14 7.60458 13.7482 7.38583 13.34C7.26651 13.1154 7.15714 12.4642 7.14719 12.4554C7.05771 11.8712 6.99805 10.9769 6.99805 9.99514C6.99805 8.96574 7.05771 8.03159 7.16708 7.45808C7.16708 7.44836 7.27646 6.92345 7.34606 6.74848C7.45543 6.49672 7.6543 6.2819 7.90288 6.14581C8.10174 6.04957 8.31055 6 8.5293 6C8.75799 6.01069 9.18555 6.15553 9.35458 6.22357C10.4682 6.65128 12.5961 8.05103 13.4114 8.90644C13.5506 9.04253 13.6998 9.20875 13.7395 9.24666C13.9086 9.46051 13.998 9.72296 13.998 10.0049Z",
    fill: "url(#paint1_linear_1404_34180)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1404_34180",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1404_34180",
    x1: 6.99805,
    y1: 6,
    x2: 6.99805,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlay);
export default __webpack_public_path__ + "static/media/ic_play.3fc779afedbaf6d8e274d4b4fd99bafd.svg";
export { ForwardRef as ReactComponent };